<template>
  <div class="subheader py-2 py-lg-4" v-bind:class="subheaderClasses" id="kt_subheader">
    <div
      class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="d-flex align-items-center flex-wrap mr-1">
        <h5 class="text-dark font-weight-bold my-2 mr-5">
          {{ title }}
        </h5>
        <ul class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2">
          <li class="breadcrumb-item">
            <router-link :to="'/'" class="subheader-breadcrumbs-home">
              <i class="flaticon2-shelter text-muted icon-1x"></i>
            </router-link>
          </li>

          <template v-for="(breadcrumb, i) in breadcrumbs">
            <li class="breadcrumb-item" :key="`${i}-${breadcrumb.id}`">
              <router-link
                v-if="breadcrumb.route"
                :key="i"
                :to="breadcrumb.route"
                class="text-muted"
              >
                {{ breadcrumb.title }}
              </router-link>
              <span class="text-muted" :key="i" v-if="!breadcrumb.route">
                {{ breadcrumb.title }}
              </span>
            </li>
          </template>
        </ul>
      </div>

      <!-- Withdrawals Dashboard refresh button-->
      <div v-if="withdrawalView" class="d-flex align-items-center flex-wrap">
        <v-btn color="primary" outlined small @click="refreshDashboard()">
          <v-icon left small>mdi-refresh</v-icon>
          Refresh
        </v-btn>
      </div>

      <div v-if="showLogger" class="d-flex align-items-center flex-wrap">
        <!-- Check Publish Button -->
        <v-btn color="info" small class="mr-4" @click="tooglePublishDialog()">
          <v-icon left small>mdi-checkbox-marked-circle-outline</v-icon>
          Check Publish
        </v-btn>

        <!-- Logger -->
        <div v-if="showLogger" class="product-import-logger">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" outlined small v-bind="attrs" v-on="on" class="mr-2">
                <v-icon left small>mdi-import</v-icon>
                Import Status
                <v-icon right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-card min-width="320" max-width="400">
              <v-card-title class="py-2 px-3">
                <v-icon left color="primary">mdi-database-import</v-icon>
                Product Import Log
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  small
                  @click.stop="getProductImportLog"
                  :loading="isRefreshingLog"
                  :disabled="isRefreshingLog"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pa-0">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="blue">mdi-identifier</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="caption">Import Run ID</v-list-item-title>
                      <v-list-item-subtitle class="text-wrap">{{
                        productImportLog?.importRunId || "N/A"
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="green">mdi-calendar-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="caption">Created At</v-list-item-title>
                      <v-list-item-subtitle>{{
                        formatDate(productImportLog?.createdAt)
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="green">mdi-calendar-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="caption">Last Update</v-list-item-title>
                      <v-list-item-subtitle>{{
                        formatDate(lastLogUpdateTime)
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon :color="getStatusColor(productImportLog?.status)">{{
                        getStatusIcon(productImportLog?.status)
                      }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="caption">Status</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-chip
                          small
                          :color="getStatusColor(productImportLog?.status)"
                          text-color="white"
                        >
                          {{ productImportLog?.status || "Unknown" }}
                        </v-chip>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="orange">mdi-message-text</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="caption">Messages Progress</v-list-item-title>
                      <v-list-item-subtitle>
                        {{ productImportLog?.completedMessages || 0 }} /
                        {{ productImportLog?.totalMessages || 0 }}
                        <v-progress-linear
                          :value="getMessageProgress()"
                          color="orange"
                          height="4"
                          class="mt-1"
                        ></v-progress-linear>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="purple">mdi-package-variant</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="caption">Total Products</v-list-item-title>
                      <v-list-item-subtitle>{{
                        productImportLog?.totalProducts || 0
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="success">mdi-check-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="caption">Succeeded Products</v-list-item-title>
                      <v-list-item-subtitle>{{
                        productImportLog?.succeededProducts || 0
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item @click="openFailedProductsDialog">
                    <v-list-item-icon>
                      <v-icon color="error">mdi-alert-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="caption">Failed Products</v-list-item-title>
                      <v-list-item-subtitle>{{
                        productImportLog?.failedProducts || 0
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
      </div>
    </div>

    <!-- Publish Confirmation Dialog -->
    <v-dialog v-model="showPublishDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5">Confirm Publication</v-card-title>
        <v-card-text class="flex flex-column" v-if="!canPublish">
          <p v-if="!canPublish" class="mb-1 font-size-lg">You have no categories to publish.</p>
          <p v-if="!canPublish" class="font-size-lg">
            Product import status is
            <span class="font-weight-bold orange--text font-size-lg">{{
              productImportLog?.status
            }}</span
            >.
          </p>
        </v-card-text>
        <v-card-text v-else-if="isPublishing">
          <span>Please wait, we initializing publication process...</span>
        </v-card-text>
        <v-card-text v-else>
          <span>Are you sure you want to publish the categories?</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showPublishDialog = false" :loading="isPublishing">Cancel</v-btn>
          <v-btn
            color="success"
            @click="publishCategories"
            :loading="isPublishing"
            :disabled="!canPublish"
          >
            Publish
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for Failed Product Details -->
    <v-dialog v-model="showFailedProductsDialog" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Failed Product Import Details</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="showFailedProductsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="failedProductsHeaders"
            :items="productImportLog?.failedProductDetails || []"
            class="elevation-1"
            dense
          >
            <template v-slot:item.failedAt="{ item }">
              {{ formatDate(item.failedAt) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss">
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;
    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import SupplierApiService from "@/core/services/api.service.supplier";
import WithdrawalsApiService from "@/core/services/api.service.withdrawals";
import { EventBus, EVENTS } from "@/core/services/event-bus";

export default {
  name: "KTSubheader",
  props: {
    breadcrumbs: Array,
    title: String
  },
  data() {
    return {
      productImportLog: null,
      showLogger: false,
      withdrawalView: false,
      showFailedProductsDialog: false, // Control dialog visibility
      showPublishDialog: false,
      hasReadyToPublishCategories: false,
      isPublishing: false,
      isRefreshingLog: false,
      lastLogUpdateTime: null,

      // Headers for the failed products table
      failedProductsHeaders: [
        { text: "Product ID", value: "productId" },
        { text: "Time", value: "failedAt" },
        { text: "Reason", value: "errorMessage" }
      ]
    };
  },
  mounted() {
    // Initialize Dropshipping API service
    SupplierApiService.init().then(() => {
      this.checkRouteAndFetchLog();
    });
  },
  watch: {
    // Watch for route changes
    $route(to) {
      this.checkRouteAndFetchLog();
    }
  },
  methods: {
    checkRouteAndFetchLog() {
      const currentPath = this.$route.path;
      if (currentPath.includes("product-catalog") || currentPath.includes("category-mapping")) {
        this.showLogger = true;
        this.getProductImportLog();
      } else if (currentPath.includes("withdrawals-dashboard")) {
        this.withdrawalView = true;
      } else {
        this.showLogger = false;
        this.withdrawalView = false;
      }
    },

    openFailedProductsDialog() {
      this.showFailedProductsDialog = true;
    },

    tooglePublishDialog() {
      this.showPublishDialog = !this.showPublishDialog;

      this.checkPublishStatus();
      this.getProductImportLog();
    },

    async getProductImportLog() {
      this.lastLogUpdateTime = new Date();
      this.isRefreshingLog = true;
      try {
        const response = await SupplierApiService.getProductImportLog();
        this.productImportLog = response.data;
      } catch (error) {
        console.error("Error fetching product import log:", error);
        throw new Error(`[SupplierApiService] getProductImportLog: ${error.message}`);
      } finally {
        setTimeout(() => {
          this.isRefreshingLog = false;
        }, 500); // 500ms delay
      }
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";
      try {
        const date = new Date(dateString);
        return date.toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit"
        });
      } catch (error) {
        return "Invalid Date";
      }
    },

    getStatusColor(status) {
      switch (status) {
        case "InProgress":
          return "orange";
        case "Completed":
          return "success";
        case "Failed":
          return "error";
        case "Pending":
          return "info";
        default:
          return "grey";
      }
    },

    getStatusIcon(status) {
      switch (status) {
        case "InProgress":
          return "mdi-progress-clock";
        case "Completed":
          return "mdi-check-circle";
        case "Failed":
          return "mdi-alert-circle";
        case "Pending":
          return "mdi-clock-outline";
        default:
          return "mdi-help-circle";
      }
    },

    getMessageProgress() {
      if (!this.productImportLog || !this.productImportLog.totalMessages) return 0;
      return (this.productImportLog.completedMessages / this.productImportLog.totalMessages) * 100;
    },

    async checkPublishStatus() {
      try {
        const response = await SupplierApiService.hasReadyToPublishCategories();
        this.hasReadyToPublishCategories = response.data;
      } catch (error) {
        console.error("Error checking publish status:", error);
        this.hasReadyToPublishCategories = false;
      }
    },

    async publishCategories() {
      this.isPublishing = true;
      try {
        await SupplierApiService.publishCategories();

        this.$bvToast.toast("Publishing successfully initialized!", {
          variant: "success",
          solid: true,
          autoHideDelay: 2000
        });

        // Refresh data after publishing
        this.getProductImportLog();
        this.checkPublishStatus();
      } catch (error) {
        this.$bvToast.toast("Publishing successfully initialized!", {
          variant: "success",
          solid: true,
          autoHideDelay: 2000
        });

        // Refresh data after publishing
        this.getProductImportLog();
        this.checkPublishStatus();

        console.error("Error publishing categories:", error);
      } finally {
        this.isPublishing = false;
        this.showPublishDialog = false;
      }
    },

    async refreshDashboard() {
      try {
        // Emit event to refresh dashboard components
        EventBus.$emit(EVENTS.REFRESH_WITHDRAWALS_DASHBOARD);
        this.$toast.success("Dashboard refresh triggered");
      } catch (error) {
        console.error("Error triggering dashboard refresh:", error);
        this.$toast.error("Failed to trigger dashboard refresh");
      }
    }
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    canPublish() {
      return this.hasReadyToPublishCategories && this.productImportLog?.status !== "InProgress";
    },

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("subheader.width") === "fluid";
    },

    subheaderClasses() {
      const classes = [];
      const style = this.layoutConfig("subheader.style");
      if (style) {
        classes.push(style);

        if (style === "solid") {
          classes.push("bg-white");
        }

        if (this.layoutConfig("subheader.fixed")) {
          classes.push("border-top");
        }
      }
      return classes.join(" ");
    }
  }
};
</script>
